import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const TnC = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path
      d="M20.6801 16.5001C21.1712 13.0544 21.0969 9.55178 20.4601 6.13008C20.2949 5.50844 19.9683 4.9415 19.5135 4.48668C19.0587 4.03185 18.4917 3.70529 17.8701 3.54008C13.9899 2.81997 10.0103 2.81997 6.13008 3.54008C5.50844 3.70529 4.9415 4.03185 4.48668 4.48668C4.03185 4.9415 3.70529 5.50844 3.54008 6.13008C2.81997 10.0103 2.81997 13.9899 3.54008 17.8701C3.70529 18.4917 4.03185 19.0587 4.48668 19.5135C4.9415 19.9683 5.50844 20.2949 6.13008 20.4601C9.55503 21.098 13.0612 21.1723 16.5101 20.6801L20.6801 16.5001Z"
      stroke="currentColor"
      fill="transparent"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M20.6801 16.5001L16.5101 16.5301V20.6301L20.6801 16.5001Z"
      stroke="currentColor"
      fill="transparent"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path d="M8 12H16.3968H8Z" fill="#AAABAD" />
    <Path
      d="M8 12H16.3968"
      stroke="currentColor"
      fill="transparent"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M8 8.08847C9.42235 8.00018 10.7662 8.00018 12.1984 8.00018C12.5319 8.00018 12.8654 8.00018 13.1205 8.00018"
      fill="#AAABAD"
    />
    <Path
      d="M8 8.08847C9.42235 8.00018 10.7662 8.00018 12.1984 8.00018C12.5319 8.00018 12.8654 8.00018 13.1205 8.00018"
      stroke="currentColor"
      fill="transparent"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M16.2332 8.05475C16.2332 8.24772 16.075 8.40583 15.8821 8.40583C15.6891 8.40583 15.531 8.24772 15.531 8.05475C15.531 7.86179 15.6891 7.70367 15.8821 7.70367C16.075 7.70367 16.2332 7.86179 16.2332 8.05475Z"
      stroke="currentColor"
      fill="transparent"
      strokeWidth="1.40735"
    />
  </Icon>
);

export default TnC;
